var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentComponent == 'List')?_c('ResultList',{attrs:{"results":_vm.results,"searchString":_vm.searchString,"trendingActive":_vm.trendingActive},on:{"goToProduct":_vm.goToProduct}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }